module.exports = __webpack_public_path__ + "static/seattle-ca3533ffac4bda23e27f00b1478de649.png";